export default {
  user: {},
};
